import React from 'react';
import { KeenIcon } from '@/components';
import { TriangleAlert } from 'lucide-react';

const ConfirmationModal = ({ show, onClose, onConfirm, message, title, btnText = 'Delete', customBtnClass = 'btn-danger', showTitle = true }) => {
  if (!show) return null;
  return (
    <div className='modal-wrapper modal-animate-fade'>
      <div className='modal-body modal-animate-scale w-4/5 max-w-xl'>
        <button
            type="button"
            onClick={onClose}
            className="modal-close-btn"
            >
            <KeenIcon icon="cross" />
        </button>
        <TriangleAlert className='size-10' />
        {showTitle && <h2 className='text-lg font-medium text-gray-900 my-2'>{title}</h2>}
        <p className={`text-sm mb-2.5 ${showTitle ? 'mt-0': 'mt-2'}`}>{message}</p>
        <div className='flex items-start justify-end'>
          <button onClick={onClose} className='btn btn-outline mt-2'>Cancel</button>
          <button onClick={onConfirm} className={`btn ${customBtnClass} btn-outline mt-2`}>{btnText}</button>
        </div>
      </div>
    </div>
  )
}

export { ConfirmationModal }
